import { Button, Box, TextField, Paper, Typography } from "@mui/material";
import { useState } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function ExportCSV({ data = [], columns = [], fileName = "export" }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const generateCSV = () => {
    let exportData = [...data];

    // Filter by date if selected
    if (startDate || endDate) {
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      exportData = exportData.filter((item) => {
        const created = new Date(item.createdAt);

        if (start && end) return created >= start && created <= end;
        if (start) return created >= start;
        if (end) return created <= end;

        return true;
      });
    }

    if (!exportData.length) {
      alert("No data found for selected date range");
      return;
    }

    const headers = columns.map((col) => col.label);
    const rows = exportData.map((item) =>
      columns.map((col) => item[col.key] ?? "")
    );

    const csv = [headers, ...rows].map((row) => row.join(",")).join("\n");
    
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    
    link.href = url;
    link.download = `${fileName}.csv`;
    link.click();
    
    URL.revokeObjectURL(url);
  };

  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        mb: 3, 
        display: 'flex', 
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1
      }}
    >
      <Typography variant="body2" color="textSecondary" sx={{ mr: 1 }}>
        Export by Date Range:
      </Typography>
      
      <TextField
        type="date"
        size="small"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        label="Start Date"
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 150 }}
      />

      <TextField
        type="date"
        size="small"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        label="End Date"
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 150 }}
      />

      {(startDate || endDate) && (
        <Button 
          variant="outlined" 
          size="small" 
          onClick={clearFilters}
          color="secondary"
        >
          Clear
        </Button>
      )}

      <Button
        variant="contained"
        onClick={generateCSV}
        startIcon={<FileDownloadIcon />}
        sx={{ ml: 'auto' }}
      >
        Export CSV
      </Button>
    </Paper>
  );
}

export default ExportCSV;